export const HistoryIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.2237 19.7883C10.1931 19.7883 8.42289 19.1252 6.91322 17.7988C5.40355 16.4727 4.53014 14.8025 4.29297 12.7883H5.30447C5.5763 14.5088 6.35997 15.939 7.65547 17.0788C8.95097 18.2185 10.4737 18.7883 12.2237 18.7883C14.1737 18.7883 15.8279 18.1092 17.1862 16.7508C18.5446 15.3925 19.2237 13.7383 19.2237 11.7883C19.2237 9.83833 18.5446 8.18416 17.1862 6.82583C15.8279 5.4675 14.1737 4.78833 12.2237 4.78833C11.1891 4.78833 10.2166 5.00691 9.30647 5.44408C8.39614 5.88125 7.59289 6.48316 6.89672 7.24983H9.37772V8.24983H5.22372V4.09608H6.22372V6.48458C6.99689 5.63575 7.90297 4.97416 8.94197 4.49983C9.98114 4.0255 11.0751 3.78833 12.2237 3.78833C13.3327 3.78833 14.3721 3.997 15.342 4.41433C16.3118 4.83166 17.1592 5.40283 17.8842 6.12783C18.6092 6.85283 19.1804 7.70025 19.5977 8.67008C20.0151 9.63991 20.2237 10.6793 20.2237 11.7883C20.2237 12.8973 20.0151 13.9367 19.5977 14.9066C19.1804 15.8764 18.6092 16.7238 17.8842 17.4488C17.1592 18.1738 16.3118 18.745 15.342 19.1623C14.3721 19.5797 13.3327 19.7883 12.2237 19.7883ZM15.4277 15.6421L11.7815 11.9961V6.78833H12.7815V11.5806L16.1352 14.9346L15.4277 15.6421Z'
        fill='currentColor'
      />
    </svg>
  )
}
